import { render, staticRenderFns } from "./EndorsementDocuments.vue?vue&type=template&id=b4a7205e&scoped=true&"
import script from "./EndorsementDocuments.vue?vue&type=script&lang=js&"
export * from "./EndorsementDocuments.vue?vue&type=script&lang=js&"
import style0 from "./EndorsementDocuments.vue?vue&type=style&index=0&id=b4a7205e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a7205e",
  null
  
)

export default component.exports